import { Assets } from 'containers/Assets'

export default Assets
